var _style, _circle, _g, _path, _g2, _g3, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCFCFC;}\n\t.st1{fill:#FFDA44;}\n\t.st2{fill:#F0F0F0;}\n\t.st3{fill:#338AF3;}\n\t.st4{fill:#D80027;}\n\t.st5{fill:#0052B4;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M299.5,178.8c0-24-19.5-43.5-43.5-43.5s-43.5,19.5-43.5,43.5h-95.7c0,23.6,20.6,42.8,44.2,42.8h-1.4 c0,23.6,19.2,42.8,42.8,42.8c0,20.9,15,38.3,34.9,42l-0.1,0.3h37.5l-0.1-0.3c19.9-3.7,34.9-21.1,34.9-42 c23.6,0,42.8-19.2,42.8-42.8h-1.4c23.6,0,44.2-19.2,44.2-42.8L299.5,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.9,302.3l-27,60.9c14.2,5.8,29.8,9,46.1,9s31.8-3.2,46.1-9l-27-60.9H236.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.3,200.2v74.9c0,42.6,55.7,55.7,55.7,55.7s55.7-13.1,55.7-55.7v-74.9L200.3,200.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.1,257.8L92.2,342l29.8-84.2h22.7l-43.4,111.3H83.1L39.3,257.8H62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M411.8,369.1V257.8h21.6v111.3L411.8,369.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M222.6,224.4v90.8c7.7,5.6,15.9,9.5,22.3,12V224.4L222.6,224.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M289.4,224.4v90.8c-7.7,5.6-15.9,9.5-22.3,12V224.4L289.4,224.4z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200.3,200.2h111.3v35.3H200.3V200.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVi);
export default __webpack_public_path__ + "static/media/vi.a4bb1f0cfad4c10c0e2488093f0236b8.svg";
export { ForwardRef as ReactComponent };